import React from 'react';
import '../styles/StatusCard.css';

interface StatusCardProps {
  count: number;
  label: string;
  status: string;
  isActive?: boolean;
  onClick: (status: string) => void;
}

const StatusCard: React.FC<StatusCardProps> = ({ count, label, status, isActive, onClick }) => {
  return (
    <div
      className={`status-card ${status} ${isActive ? 'active' : ''}`}
      onClick={() => onClick(status)}
    >
      <div className="status-number">{count}</div>
      <div className="status-label">{label}</div>
    </div>
  );
};

export default StatusCard;